// extracted by mini-css-extract-plugin
export default {"title":"h7lvr","content":"ESbmT","divider":"H18PI"};